import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import {
  API_URL,
  ICreateDebitCardRequest,
  IPaymentMethodOwnerDtoPaymentMethodOwnerTypeEnum,
  IPaymentMethodResponseDto,
  IPaymentMethodResponseDtoPaymentMethodTypeEnum,
} from '@/dtos';
import { PaymentMethodOwnerType, PaymentMethodType } from '@/modules/employee/employee.types';

import { QUERY_KEY } from './usePaymentMethods.query';

interface Params {
  employeeId: string;
}

const useCreateCheckPaymentMethodQuery = ({ employeeId }: Params) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess, isLoading } = useMutation(
    () =>
      api.post<ICreateDebitCardRequest, IPaymentMethodResponseDto, IPaymentMethodResponseDto>(
        API_URL.PAYMENT_METHODS,
        {
          payment_method_type:
            PaymentMethodType.CHECK as unknown as IPaymentMethodResponseDtoPaymentMethodTypeEnum,
          payment_method_owner: {
            employee_id: _.toNumber(employeeId),
            payment_method_owner_type:
              PaymentMethodOwnerType.EMPLOYEE as unknown as IPaymentMethodOwnerDtoPaymentMethodOwnerTypeEnum,
          },
        },
        {
          params: {
            employee_id: employeeId,
          },
        }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    isLoading,
    isSuccess,
    handleCreate: mutateAsync,
  };
};

export default useCreateCheckPaymentMethodQuery;
